module.exports = {"id":"232270","name":"Timothy Fosu-Mensah","rating":"75","photo":"./data/images/photos/2/232270.png","club":{"name":"Crystal Palace","logo":"./data/images/clubs/CrystalPalace.png"},"positions":["DD","DC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/TimothyFosu-Mensah0.json
// module id = 4148
// module chunks = 0